export enum LOCAL_STORAGE_KEYS {
  auth = 'tenthousandcoffees_token',
  refresh = 'ttc_refresh_token',
  tenant = 'ttc_tenant_token',
}
